import "./App.css";
import logo from "./assets/econbeauty.webp";
import { TelegramButton } from "./telegram";
import icon from "./assets/icons/whatsapp.svg";

type LPConfig = {
  header: string;
  title: string;
  title2: string;
  subtitle: string;
  ctaButton: string;
  ctaSubtitle: string;
  footer: string;
};

const CONFIG: Record<string, LPConfig> = {
  "ph-geral": {
    header: "🎯 MELHORES PROMOÇÕES E CUPONS DO UNIVERSO FEMININO",
    title: "🚨 GRUPO VIP 🚨",
    title2: "100% GRATUITO",
    subtitle: "Produtos com 50% 60% 70% OFF 🥰",
    ctaButton: "GRUPO WHATSAPP",
    ctaSubtitle: "✨ JÁ SOMOS +100 MIL MEMBROS ✨",
    footer: "Direitos Reservados",
  },
};

function App() {
  const config = CONFIG["ph-geral"];

  return (
    <div className="container">
      <header className="header">
        <h1>{config.header}</h1>
      </header>

      <main className="main-content">
        <div className="vip-group-title">
          <p>{config.title}</p>
          <p>{config.title2}</p>
        </div>

        <div className="discount-text">{config.subtitle}</div>

        <div className="cta-container">
          <div className="icon-container">
            <img src={logo} alt="Shopping Bag" className="shopping-bag-icon" />
          </div>

          <a
            href="http://linktr.it/econbeauty"
            className="cta-button telegram-button-content animated-fast animated tada"
          >
            <img src={icon} alt="Ícone Whats" className="social-icon" />
            {config.ctaButton}
          </a>

          <TelegramButton
            href="https://t.me/economiabeauty"
            ariaLabel="Telegram button"
          >
            CANAL TELEGRAM
          </TelegramButton>

          <div className="members-count">{config.ctaSubtitle}</div>
        </div>
      </main>

      <footer className="footer">{config.footer}</footer>
    </div>
  );
}

export default App;
